module.exports = __webpack_public_path__ + "img/NMI.c471dbf9.jpg";